import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBell = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M11.014 2.662c.261-.27.616-.422.986-.422s.725.152.986.422.408.636.408 1.018c0 .433.242.827.621 1.013a7.668 7.668 0 0 1 3.072 2.738 8.015 8.015 0 0 1 1.265 3.956V15.2c0 .045.003.09.008.135.108.92.413 1.803.892 2.585H4.749a6.372 6.372 0 0 0 .891-2.585c.005-.045.008-.09.008-.135v-3.813a8.015 8.015 0 0 1 1.265-3.956 7.669 7.669 0 0 1 3.051-2.728 1.097 1.097 0 0 0 .473-.423c.113-.184.172-.4.169-.619.005-.375.15-.734.408-1ZM7.82 20.16H2.085c-.493 0-.924-.343-1.05-.835a1.135 1.135 0 0 1 .515-1.26c.528-.308.978-.74 1.314-1.262a4.08 4.08 0 0 0 .615-1.675V11.36l.001-.053A10.306 10.306 0 0 1 5.11 6.19a9.888 9.888 0 0 1 3.397-3.23 3.719 3.719 0 0 1 .974-1.881A3.507 3.507 0 0 1 12 0a3.51 3.51 0 0 1 2.52 1.078c.501.518.838 1.174.974 1.882a9.888 9.888 0 0 1 3.397 3.229 10.305 10.305 0 0 1 1.63 5.171v3.768c.08.6.29 1.172.615 1.675.336.522.786.954 1.314 1.262.428.251.64.768.514 1.26a1.091 1.091 0 0 1-1.049.835H16.18a3.923 3.923 0 0 1-1.264 2.709A4.286 4.286 0 0 1 12 24a4.287 4.287 0 0 1-2.916-1.131A3.923 3.923 0 0 1 7.82 20.16Zm2.174 0c.04.374.22.745.54 1.044.372.345.897.556 1.466.556s1.095-.211 1.466-.556c.321-.299.5-.67.54-1.044H9.994Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBell);
export default ForwardRef;
